module.exports = __webpack_public_path__ + "img/bc_pic6.f6cb1a4c.png";